module.exports = __webpack_public_path__ + "static/villa-pre-case-study-8b5550cac5b49301719b61419651631c.webp";